import { GetToursAsyncService } from 'sletat-api-services/lib/module/getTours/getToursAsyncService';
import { GetToursRequestParams } from 'sletat-api-services/lib/module/getTours/getToursRequest';
import { Tour } from 'sletat-api-services/lib/module/getTours/models/tours';


import { MODULE_HOST_NAME } from '../../consts/hosts';

export { Tour } from 'sletat-api-services/lib/module/getTours/models/tours';
export { GetToursAsyncServiceEvents, GetToursAsyncService, GetToursErrorTypes } from 'sletat-api-services/lib/module/getTours/getToursAsyncService';
export { GetToursRequestParams } from 'sletat-api-services/lib/module/getTours/getToursRequest';
export { WrappedGetLoadStateResponse } from 'sletat-api-services/lib/module/getLoadState/getLoadStateResponse';


// TODO selkin: маппинг типа номера после нужно вынести на бэк, дропнув всё содержимое этого файла
export interface ExtendedTour extends Tour {
    linkedRoomTypeName: string;
}

export function createSearcherService(params: GetToursRequestParams, reCaptchaToken: string, availableResultsEventTimeout?: number): GetToursAsyncService {
    return new GetToursAsyncService(params, {
        host: MODULE_HOST_NAME,
        isSearchWithRobot: true,
        headers: {
            reCaptchaToken
        }
    }, availableResultsEventTimeout);
}
